var map = {
	"./action-options/marketing-a.svg": 415,
	"./action-options/marketing-b.svg": 7629,
	"./action-options/marketing-c.svg": 1550,
	"./action-options/offer-campaign-a.svg": 1709,
	"./action-options/offer-campaign-b-c.svg": 1622,
	"./actions/financing.svg": 4586,
	"./actions/hardware.svg": 7134,
	"./actions/innovation.svg": 3495,
	"./actions/marketing.svg": 4312,
	"./actions/offer-campaign.svg": 7397,
	"./actions/shop-interior-design.svg": 9197,
	"./actions/staff-1.svg": 1990,
	"./actions/staff-2.svg": 5813,
	"./actions/tshirt-designs.svg": 2854,
	"./actions/tshirt-supplier.svg": 5108,
	"./actions/upskilling.svg": 777,
	"./animations/between-rounds.gif": 1734,
	"./backgrounds/background-office-character.png": 1984,
	"./backgrounds/background-office.png": 9577,
	"./backgrounds/background-page-1.svg": 3135,
	"./backgrounds/background-page-2.svg": 2037,
	"./backgrounds/background-page.svg": 6881,
	"./backgrounds/background-production-character.png": 1904,
	"./backgrounds/background-production.png": 8897,
	"./backgrounds/background-shop-character.png": 6435,
	"./backgrounds/background-shop.png": 9507,
	"./backgrounds/background-splash-characters.png": 9946,
	"./backgrounds/background-splash-shop.png": 4697,
	"./designs/friend_01.png": 1398,
	"./designs/friend_02.png": 768,
	"./designs/graffiti_01.png": 5825,
	"./designs/graffiti_02.png": 6473,
	"./designs/gueststar_01.png": 348,
	"./designs/horrorart_01.png": 9146,
	"./designs/horrorart_02.png": 6603,
	"./designs/horrorart_03.png": 7176,
	"./designs/indieband_01.png": 8461,
	"./designs/indieband_02.png": 6540,
	"./designs/indieband_03.png": 8935,
	"./designs/indieband_04.png": 669,
	"./designs/kawaii_01.png": 9074,
	"./designs/kawaii_02.png": 8671,
	"./designs/kawaii_03.png": 7642,
	"./designs/kawaii_04.png": 8507,
	"./designs/kawaii_05.png": 9677,
	"./designs/metalband_01.png": 378,
	"./designs/metalband_02.png": 6849,
	"./designs/metalband_03.png": 4929,
	"./designs/psychedelic_01.png": 1918,
	"./designs/psychedelic_02.png": 4974,
	"./designs/psychedelic_03.png": 5898,
	"./designs/start_01.png": 4531,
	"./designs/stjernekunst_01.png": 1930,
	"./designs/streetart_01.png": 2735,
	"./designs/streetart_02.png": 6162,
	"./designs/streetart_03.png": 7533,
	"./fund-logo.svg": 226,
	"./gamelab-logo.svg": 4334,
	"./icons/flags/dk.svg": 4332,
	"./icons/flags/gl.svg": 3943,
	"./icons/icon-arrow-down.svg": 2337,
	"./icons/icon-check-blue.svg": 4171,
	"./icons/icon-check.svg": 9598,
	"./icons/icon-close.svg": 84,
	"./icons/icon-cookie.svg": 4857,
	"./icons/icon-info-button.svg": 4231,
	"./icons/icon-info-button1.svg": 8833,
	"./icons/icon-info.svg": 8579,
	"./icons/icon-loading-2.svg": 7056,
	"./icons/icon-loading.svg": 1328,
	"./icons/icon-minus.svg": 3226,
	"./icons/icon-office.svg": 3446,
	"./icons/icon-play.svg": 7023,
	"./icons/icon-plus.svg": 4634,
	"./icons/icon-round-blue.svg": 926,
	"./icons/icon-round-current.svg": 4209,
	"./icons/icon-round-future.svg": 6244,
	"./icons/icon-round-grey.svg": 7610,
	"./icons/icon-round-past.svg": 4261,
	"./icons/icon-round-yellow.svg": 4647,
	"./icons/icon-video.svg": 5816,
	"./logo.svg": 2835,
	"./video-thumb.jpg": 1853
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;